import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { Link } from 'react-router-dom';
import Loading from '../Loader/Loader';
import {
    getPortalSettings,
    checkMarketSourceGuid
} from "../../redux/actions/UserActions";
import CheckValidAuthorized from '../Error/AuthorizationMessage';

class ValidateMarketSource extends Component {

    constructor(props) {
        super(props)
        this.state = {
            success: false,
            message: '',
            isvalid: false,
            portallogo: localStorage.getItem("publicportallogo")
        }
    }
    componentDidMount() {
        localStorage.clear();
        this.props.getPortalSettings();
        const getGuiId = `?Id=${this.props.match.params.id}`;
        this.props.checkMarketSourceGuid(getGuiId)
    }
    componentDidUpdate(prevProps) {
        if (prevProps.marketsourcedata !== this.props.marketsourcedata) {
            if (this.props.marketsourcedata.Success) {
                localStorage.setItem('isvalid', 'true');
                this.props.history.push({
                    pathname: '/CreateClient',
                    state: {
                        marketSourceId: this.props.match.params.id
                    }
                });
            }

        }

        if ((prevProps.portallogo && localStorage.getItem('publicportallogo')) && prevProps.portallogo !== localStorage.getItem('publicportallogo')) {
            this.setState({
                portallogo: localStorage.getItem('publicportallogo')
            });
        }
    }

    render() {

        if (this.props.error) {
            return (<CheckValidAuthorized />)
        }
        return (
            <div>
                {this.props.fetching && !this.props.error ? (

                    <div className="full-background">
                        <div className={"header-" + window.globalConfig.CustomerName + " container-fluid"}>
                            <div className="row align-items-center">
                                <div className="col-6 d-flex">
                                    <div className="logo">
                                        <Link to="/"><img src={this.state.portallogo} height="100%" /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Loading />
                    </div>
                ) : (
                    <div>

                        <div className={"header-" + window.globalConfig.CustomerName + " container-fluid"}>
                            <div className="row align-items-center">
                                <div className="col-6 d-flex">
                                    <div className="logo">
                                        <Link to="/"><img src={this.state.portallogo} height="100%" /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
const mapStateToProps = (state) => ({

    portalSettings: state.user.portalSettings,
    marketsourcedata: state.user.marketsourcedata,
    fetching: state.user.fetching,
    error: state.error.isError,
});

const mapDispatchToProps = {
    getPortalSettings,
    checkMarketSourceGuid
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ValidateMarketSource));


